import { PortalProductConfig, getProductWithVariants, ProductWithVariants } from '../../models/product';
import { SingleInsurantWidgetComponent } from '../../customer-portal/widgets/single-insurant-widget/single-insurant-widget.component';
import { defaultContractWidgets } from '../../config/default-contract-widgets';

const portalConfig: PortalProductConfig = {
    icon: 'incident',
    widgets: [...defaultContractWidgets, { component: SingleInsurantWidgetComponent }],
};

export const accidentInsuranceForPupils: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-unfallversicherung',
    title: 'Schüler-Unfallversicherung',
    fullTitle: 'Schüler-Unfallversicherung',
    insuranceTypeName: 'Unfall Schüler',
    insuranceTypeId: 9,
    legacy: true,
    portalConfig,
});
